'use strict'

import TruncateStrings from '../tools/TruncateStrings'
import Swiper from '../../components/swiper'

export default class Lastnews
{
  constructor( )
  {
    this.$elem = $('.LastNews')

    if( this.$elem.length > 0 ){
      this.truncateStrings = new TruncateStrings()

      this.$elem = $('.LastNews')
      this.$container = $('.LastNews__container')
      this.$items = this.$elem.find('.item .item__content')
      this.$slider = {}

      let self = this

      $(document).ready(function(){
        self.truncateStrings.createUniqueContainer( self.$items )
        self.truncateStrings.truncateStrings( self.$items, {
            0: 160,
            1200: 160
        })

        if( window.innerWidth < 768 ){
            self.generateSlider()
        }
        else{
          self.$container.addClass('col grid-top-spaceBetween-noGutter')
          self.$container.children().addClass('col grid-middle-noGutter')

          let maxHeight = 0

          $.each(self.$items.siblings(), function( i,val ){
            if( $(this).outerHeight() >= maxHeight ){
              maxHeight = $(this).outerHeight()
            }
          })

          self.$items.siblings().css({
            'height' : maxHeight
          })
        }
      })

      $(window).resize( ()=> {
        self.truncateStrings.truncateStrings( self.$items, {
          0: 160,
          1200: 160
        })
      })

      $(window).on("orientationchange", ()=> {
        self.truncateStrings.truncateStrings( self.$items, {
          0: 160,
          1200: 160
        })
      })
    }
  }

  generateSlider()
  {
    let $items = this.$container.children()

    this.$container.addClass('with-slider')
    this.$container.append( '<div class="swiper-wrapper"></div>' )
    this.$container.append( '<a href="#" class="button_next"></a>' )

    $.each($items, function( i,val ){
      $(this).siblings('.swiper-wrapper').append( $(this) )
      $(this).addClass('swiper-slide')
    })

    this.$slider = new Swiper('.LastNews__container', {
      slidesPerView: 1,
      nextButton: '.LastNews__container .button_next',
      loop: true,
      autoHeight: true,
    })
  }
}
